import React, {useEffect, useState} from 'react';
import {Navigate, Outlet, useLocation, useSearchParams} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {actionCreators, type State} from '@App/state';
import {DriverDataService} from '@App/apis/rest/ayvens/driverData/driverDataService';
import {bindActionCreators} from '@reduxjs/toolkit';
import {Loader} from '@App/Components/Loader';

export const TokenProtectedRoutes = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('jwt');
    const driverData = useSelector((state: State) => state.auth.driverData);

    const dispatch = useDispatch();
    const { setDriverData } = bindActionCreators(actionCreators, dispatch);
    const currentLocation = useLocation();

    const [isLoading, setIsLoading] = useState(false);
    const [errorOccurred, setErrorOccurred] = useState(false);

    useEffect(() => {
        if (token && !driverData) {
            setIsLoading(true);
            setErrorOccurred(false);
            const driverDataService = new DriverDataService(window.rest_url);

            driverDataService.getFromJwt(token)
                .then(result => setDriverData(result))
                .catch(() => setErrorOccurred(true))
                .finally(() => setIsLoading(false));
        } else {
            setIsLoading(false);
            setErrorOccurred(false);
        }
    }, [token, driverData, setDriverData]);

    // TODO there could be some edge cases that I didn't catch in this first draft.
    // Maybe thoroughly check if everything works according to plan.
    if (isLoading) return <Loader />;
    if ((token && errorOccurred) || !token) {
        return <Navigate to='/partner/ayvens/login' state={{ location: currentLocation }} replace />;
    }
    if (token && driverData) return <Outlet />;

    return null;
};
